<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="sample-overview" :busy="loadingSampleCollection">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>Sample Request</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>

                <template slot="body" v-if="sampleCount > 0">

                    <b-container v-bind:class="[{ busy: busy }, 'opacity-transition']">
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <pb-spinner v-if="busy"/>
                        <b-row>
                            <b-col lg="4">
                                <b-row v-if="hasRole('Admin')" class="mb-2">
                                    <b-col>
                                        <b-form-select v-model="selectedCheckoutType"
                                                       :options="checkoutTypes"></b-form-select>
                                    </b-col>
                                </b-row>
                                <div v-if="selectedCheckoutType === 'sample'" class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>CUSTOMER ADDRESS</h4>
                                            {{user.firstName}} {{user.lastName}}
                                            <br/>
                                            {{user.externalData.company.companyName}}<br/><br/>
                                            {{user.externalData.company.street}}<br/>
                                            {{user.externalData.company.country}}-{{user.externalData.company.zipCode}}
                                            {{user.externalData.company.city}}

                                        </b-col>
                                    </b-row>
                                    <pb-address class="mt-2" ref="addressForm" @input="updateAddress"></pb-address>
                                </div>
                                <div v-if="selectedCheckoutType === 'first-sample'" class="bg-gray p-4">
                                    <v-select v-model="selectedCustomer" :options="contactList"
                                              :filter="filterFunction" v-if="diamondUsers">
                                        <template v-slot:cell(option)="option">
                                            {{ option.firstName }} {{ option.lastName }} {{option.company.companyName}}
                                        </template>
                                    </v-select>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>SAMPLE OVERVIEW</h4>
                                            <div :key="key" v-for="(item, key) in sampleItemList">
                                                <sample-checkout-item :item="item"/>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class=" bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>INTERNAL ORDER REFERENCE
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-input
                                                    id="sampleOrderReference"
                                                    name="sampleOrderReference"
                                                    type="text"
                                                    v-model.trim="sampleOrderReference"
                                                    placeholder="Internal Order Reference"
                                            ></b-form-input>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>DELIVERY DATE</h4>
                                            <b-form-datepicker

                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="en" id="preferredDeliveryDate" name="preferredDeliveryDate"
                                                    :min="new Date()"
                                                    v-validate="'required'"
                                                    v-model="preferredDeliveryDate" class="mb-2 "></b-form-datepicker>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>COMMENT
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-textarea
                                                    id="comment"
                                                    name="comment"
                                                    class="h-auto"
                                                    v-model="sampleOrderComment"
                                                    rows="4"
                                                    placeholder="Additional information..."
                                                    no-resize
                                            ></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row class="mt-2">
                                    <b-col>
                                        <b-button v-if="selectedCheckoutType != 'first-sample'" variant="primary"
                                                  class="btn-block"
                                                  @click="sendSampleRequest()">
                                            FINALIZE SAMPLE REQUEST
                                        </b-button>
                                        <b-button v-else variant="primary" class="btn-block"
                                                  @click="sendFirstSampleRequest()">
                                            FINALIZE FIRST-SAMPLE REQUEST
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
                <template slot="body" v-else>
                    <b-container>
                        <b-row>
                            <b-col>
                                <b-alert variant="warning" show>No samples selected.</b-alert>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>

<script>


    import {mapActions, mapGetters, mapState} from "vuex";
    import Address from "../../components/checkout/Address";
    import SampleCheckoutItem from "./SampleCheckoutItem";
    import SampleApi from "@shared/_api/sample";
    import UserDiamondApi from "@shared/_api/userDiamond";

    export default {
        name: 'sample-checkout',
        props: {},
        components: {
            'pb-address': Address,
            'sample-checkout-item': SampleCheckoutItem
        },
        data() {
            return {
                busy: false,
                submitError: null,
                addressData: {
                    deliveryAddressSameAsBilling: true,
                    deliveryAddress: {
                        recipient: null,
                        recipientSecondary: null,
                        street: null,
                        zipCode: null,
                        city: null,
                        country: null
                    },
                    selectedAddressType: 'SELECT_ADDRESS'
                },
                sampleOrderComment: null,
                sampleOrderReference: null,
                selectedCheckoutType: 'sample',
                checkoutTypes: [
                    {value: 'sample', text: 'Musterauftrag'},
                    {value: 'first-sample', text: 'Erstmusterauftrag'}
                ],
                diamondUsers: null,
                selectedCustomer: null,
                customerId: null,
                preferredDeliveryDate: null
            };
        },
        mounted() {
          this.preferredDeliveryDate = new Date();
          this.preferredDeliveryDate.setDate(this.preferredDeliveryDate.getDate() + 1);
        },
        methods: {
            ...mapActions("sample", ["fetchSampleList"]),
            filterFunction(options, search) {
                let lowerCaseSearch = search.toLowerCase();
                return options.filter(option => {
                    return (option.firstName && option.firstName.toLowerCase().indexOf(lowerCaseSearch) > -1) || (option.lastName && option.lastName.toLowerCase().indexOf(lowerCaseSearch) > -1) || (option.company && option.company.companyName.toLowerCase().indexOf(lowerCaseSearch) > -1);
                });
            },
            updateAddress(addressData) {
                this.addressData = addressData;
            },
            sendFirstSampleRequest() {
                this.busy = true;
                this.submitError = null;

                let order = {
                    deliveryAddressId: null,
                    comment: this.sampleOrderComment,
                    deliveryAddressType: 'COMPANY',
                    reference: this.sampleOrderReference,
                    orderType: 'FIRST',
                    seasonId: 0,
                    externalDiamondUserId: this.selectedCustomer.company.externalAccountType == 'DIAMOND' ? this.selectedCustomer.company.id : null,
                    externalDiamondLightUserId: this.selectedCustomer.company.externalAccountType == 'DIAMOND_LIGHT' ? this.selectedCustomer.company.id : null,
                    recipient: this.selectedCustomer.company.companyName,
                    recipientSecondary: this.selectedCustomer.company.companyName,
                    street: this.selectedCustomer.company.street,
                    zipCode: this.selectedCustomer.company.zipCode,
                    city: this.selectedCustomer.company.city,
                    country: this.selectedCustomer.company.country
                };

                return SampleApi.checkoutAdmin(order).then(() => {
                    return this.fetchSampleList();
                }).then(() => {
                    this.$router.push({name: 'sample-checkout-success'})
                }).catch(() => {
                    this.submitError = "An unexpected error occured processing your order. Please contact our customer support."
                }).finally(() => {
                    this.busy = false;
                });
            },
            sendSampleRequest() {
                this.busy = true;

                this.submitError = null;

                this.$refs.addressForm.$validator.validate().then(valid => {
                    if (valid) {

                        let order = {
                            deliveryAddressId: this.addressData.selectedDeliveryAddress ? this.addressData.selectedDeliveryAddress.id : null,
                            comment: this.sampleOrderComment,
                            deliveryAddressType: (this.addressData.deliveryAddressSameAsBilling === false) ? 'NEW' : 'COMPANY',
                            reference: this.sampleOrderReference,
                            orderType: 'SAMPLE',
                            seasonId: 0,
                            recipient: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.recipient : this.user.firstName + " " + this.user.lastName,
                            recipientSecondary: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.recipientSecondary : this.user.externalData.company.companyName,
                            street: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.street : this.user.externalData.company.street,
                            zipCode: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.zipCode : this.user.externalData.company.zipCode,
                            city: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.city : this.user.externalData.company.city,
                            country: (this.addressData.deliveryAddressSameAsBilling === false) ? this.addressData.deliveryAddress.country.locale : this.user.externalData.company.country,
                            preferredDeliveryDate: this.preferredDeliveryDate
                        };

                        return SampleApi.checkout(order).then(() => {
                            this.$tracker.trackEvent({
                                label: 'Checkout Sample Order',
                                type: 'CHECKOUT_ORDER_SAMPLE'
                            });
                            return this.fetchSampleList();
                        }).then(() => {
                            this.$router.push({name: 'sample-checkout-success'})
                        }).catch(() => {
                            this.submitError = "An unexpected error occured processing your order. Please contact our customer support."
                        })
                    }
                    return Promise.resolve();
                }).finally(() => {
                    this.busy = false;
                });
            }
        },
        computed: {
            ...mapState("sample", ['loadingSampleCollection']),
            ...mapState('account', ['user']),
            ...mapGetters('sample', ['sampleItemList', 'sampleCount']),
            ...mapGetters('account', ['hasRole']),
            contactList() {
                let contactList = [];

                if (this.diamondUsers && this.diamondUsers.length > 0) {
                    contactList = this.diamondUsers.map(contact => {
                        return Object.assign(contact, {label: ((contact.firstName) ? contact.firstName + " " : '') + contact.lastName + " (" + contact.company.companyName + ")"});
                    })
                }
                return contactList;
            }
        },
        watch: {
            selectedCheckoutType(selectedCheckoutType) {
                if (selectedCheckoutType === 'first-sample' && !this.diamondUsers) {
                    UserDiamondApi.fetchAll().then(diamondUsers => {
                        this.diamondUsers = diamondUsers;
                    });
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
